<script>
    import EventReminderBlock from "../../components/event_reminder/EventReminderBlock";
    import ImageWithSliderOnRight from "../../components/home/ImageWithSliderOnRight";
    import FeaturedOnIcons from "../../components/shared/FeaturedOnIcons";
    import GoogleReviews from "../../components/home/v2/GoogleReviews";
    import FeaturedArtists from "../../components/artists/FeaturedArtists";
    import Playlist from "../../components/shared/Playlist";
    import TextWithImage from "@songfinch/customer/components/global/TextWithImage";
    import {transform, size, map} from "lodash-es";

    export default {
        name: "LandingTemplate",
        components: {FeaturedArtists, GoogleReviews, FeaturedOnIcons, ImageWithSliderOnRight, EventReminderBlock, Playlist, TextWithImage},
        data() {
            return {
                homeData: null,
            };
        },
        computed: {
            data() {
                return this.$store.state.cms.pageData;
            },
            showPage() {
                return this.homeData && this.data;
            },
            featuredArtistData() {
                if (this.homeData && this.data) {
                    if (this.homeData.featured_artist && !this.data.featured_artist) {
                        return this.homeData.featured_artist;
                    } else if (!this.homeData.featured_artist && this.data.featured_artist) {
                        return this.data.featured_artist;
                    }
                    return transform(this.homeData.featured_artist, (r, v, k) => {
                        if (typeof this.data.featured_artist?.[k] === "object") {
                            r[k] = size(this.data.featured_artist?.[k]) ? this.data.featured_artist?.[k] : v;
                        } else {
                            r[k] = this.data.featured_artist?.[k] || v;
                        }
                    });
                }
                return null;
            },
            songs() {
                return map(this.data.song_examples?.songs, song => ({
                    image: song?.artist_image,
                    name: song.artist,
                    link: song.artist_url,
                    audio: song.audio,
                    song_subtitle: song.genre,
                    song_title: song.title
                }));
            },
        },
        async created() {
            this.homeData = await this.$store.dispatch("cms/getFields", {
                queryParams: {group: "/old-home-data"},
            });
        }
    };
</script>

<template>
    <div v-if="showPage" class="landingTemplate page @pt-0 tablet-lg:@pt-8">
        <TextWithImage
            v-if="data.welcome_section"
            class="welcomeSection @mb-20"
            :content="data.welcome_section.content"
            :image="data.welcome_section.image"
        />
        <FeaturedOnIcons v-if="homeData.featured_on?.list" class="@mb-20" :list="homeData.featured_on.list"/>
        <ImageWithSliderOnRight v-if="homeData.image_with_slider" :data="homeData.image_with_slider"/>

        <div class="@pt-16 @pb-20 @bg-sfc-light-beige">
            <div v-if="data.song_examples" class="@container">
                <h2 v-if="data.song_examples.title" class="@text-center @mb-10" v-html="data.song_examples.title"/>
                <Playlist :songs="songs"/>
                <div v-if="data.song_examples.button_url" class="@text-center @mt-12">
                    <router-link class="mkButton beige" :to="data.song_examples.button_url">
                        View entire playlist
                    </router-link>
                </div>
            </div>
        </div>

        <FeaturedArtists v-if="featuredArtistData" class="@pb-20 @pt-16" :no-slide="true" :data="featuredArtistData"/>
        <EventReminderBlock/>
        <GoogleReviews :title="data?.trust_section?.title" :image="data?.trust_section?.image" class="@pt-12 @pb-0 tablet:@pb-8"/>
    </div>
</template>

<style scoped>
    @import "@songfinch/customer/stylesheets/includes/mixins/index.pcss";
    .landingTemplate{
        :deep(.welcomeSection .contentWithButton) {
            h1 {
                margin-bottom: 15px;
                @screen desktop{
                    margin-bottom: 25px;
                }
            }

            a:not(.regLink) {
                padding: 20px 33px;
                @include font(National, 18px, 20px, 600, 0.5px);
                text-transform: uppercase;
            }
        }
    }
</style>
